import { AxiosInstance } from "axios";

export default class AreaCodesService {
  private axios: AxiosInstance;

  constructor(axios: AxiosInstance) {
    this.axios = axios;
  }

  public async getAllAreaCodes(): Promise<any> {
    const url: string = "/area-codes";
    return this.axios.get(url);
  }
}
